const getCanvas = (html) => {
  const canvas = document.createElement('div');
  canvas.innerHTML = html;

  return canvas;
};

export default getCanvas;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/helpers/getCanvas.js
 **/